
export const CROP_COLOR_MAP: { [key: string]: string } = {
  'Cotton': '#c0c0c0',
  'Wheat': '#ffe119',
  'Corn': '#00FFFF',
  'Rice': '#ffffff',
  'Soybean': '#78A8FC',
  'Sunflower': '#ffbf00',
  'Tomato': '#e6194b',
  'Potato': '#D0AB8B',
  'Mung bean': '#AAFFC3',
  'Watermelon': '#f032e6',
  'Onion': '#ffcc99',
  'Carrot': '#ff7f00',
  'Cucumber': '#008000',
  'Cucumbers': '#008000',
  'Hot Pepper': '#800000',
  'Chickpea': '#e6beff',
  'Cabbage': '#a2c523',
  'Intensive Orchards – Walnut': '#D8B99D',
  'Intensive Orchards – Apple': '#bcf60c',
  'Intensive Orchards – Vineyard': '#6750A4',
  'Intensive Orchards – Pomegranate': '#990033'
};


export const FALLBACK_SEASON_COLORS = [
  '#FF6B6B',
  '#4ECDC4',
  '#45B7D1',
  '#96CEB4',
  '#FFEAA7',
  '#DDA0DD',
  '#98FB98',
  '#F4A460'
];